import { render, staticRenderFns } from "./goodsChooseItem.vue?vue&type=template&id=6607dce0&scoped=true"
import script from "./goodsChooseItem.vue?vue&type=script&lang=js"
export * from "./goodsChooseItem.vue?vue&type=script&lang=js"
import style0 from "./goodsChooseItem.vue?vue&type=style&index=0&id=6607dce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6607dce0",
  null
  
)

export default component.exports